import { createSimpleStore } from './factories/simpleStoreFactory';

type LayoutState = {
  hasPadding: boolean;
};

type LayoutActions = {
  setHasPadding: (value: boolean) => void;
  resetPadding: () => void;
};

export type LayoutStore = LayoutState & LayoutActions;

export const useLayoutStore = createSimpleStore<LayoutState, LayoutActions>({
  name: 'LayoutStore',
  initialState: {
    hasPadding: true
  },
  actions: (set) => ({
    setHasPadding: (value: boolean) => set({ hasPadding: value }),
    resetPadding: () => set({ hasPadding: true })
  })
});
